import { Box } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useScheduleEditorReviewDecisions } from "./hooks/use-schedule-editor-review-decisions"
import { AuthoringEditorRejectionBanner } from "./authoring-editor-rejection-banner"

export function AuthoringTaskRejectionEntry() {
    const { task, target, editMode, amendsContext, getTaskAmendsKey } = useBoundContext()
    const reviewDecisionByAmendsKey = useScheduleEditorReviewDecisions()
    if (!amendsContext) {
        throw new Error("AuthoringTaskRejectionEntry requires amendsContext")
    }
    if (!getTaskAmendsKey) {
        throw new Error("AuthoringTaskRejectionEntry requires getTaskAmendsKey")
    }

    const contextTarget = target ?? task
    const amendsKey = contextTarget ? getTaskAmendsKey(contextTarget) : null
    const isOpen = amendsKey ? amendsContext.getAmendsState(amendsKey).isOpen : false
    const decision = amendsKey ? reviewDecisionByAmendsKey[amendsKey] : null
    const hasDecision = decision?.payload?.status === "rejected"

    if (!editMode || !amendsKey || !hasDecision) return null

    return (
        <Box sx={{ pl: { xs: 2, sm: 5 }, pr: 2, pb: 2, pt: isOpen ? 0 : 1 }}>
            <AuthoringEditorRejectionBanner amendsKey={amendsKey} />
        </Box>
    )
}
